import { render, staticRenderFns } from "./SubAccount.vue?vue&type=template&id=52453e22&scoped=true&"
import script from "./SubAccount.vue?vue&type=script&lang=js&"
export * from "./SubAccount.vue?vue&type=script&lang=js&"
import style0 from "./SubAccount.vue?vue&type=style&index=0&id=52453e22&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52453e22",
  null
  
)

export default component.exports